export class StorageConstants {
  public readonly SSO_CONFIRM_RESP = "SSO_CONFIRM_RESP";
  public readonly INPROGRESS_ADD_ACCOUNT_FORM = "INPROGRESS_ADD_ACCOUNT_FORM";
  public readonly MDM_PROFILE = "MDM_PROFILE";
}
